module.exports = __webpack_public_path__ + "media/images/metronic/social/evernote-4c7a859aebef824143dd59c56ab703e8.png";